import React, { useEffect, useState } from "react";
import {
  CButton,
  CCol,
  CContainer,
  CRow,
  CCardBody,
  CCard,
  CCardHeader,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from "@coreui/react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
  getLoanData,
  getLoanId,
  updateLoan,
} from "src/redux/actions/customerAction";
import { useSelector } from "react-redux";
import LoanApproveModal from "./loanApproveModal";
import { formatDate } from "src/services/helpers";

const LoanDetailsData = ({ customerData, setKey }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const { loanAmountRequested, id } = customerData;
  const { loans, loandetails, loandata } = useSelector(
    (state) => state?.customerReducer
  );
  const [status, setStatus] = useState(false);
  const [loanAmount, setLoanAmount] = useState(0);
  const [checkedState, setCheckedState] = useState({});

  // Handler to toggle the checkbox state

  const SchemaName = sessionStorage.getItem("schemaName");

  useEffect(() => {
    setLoanAmount(loanAmountRequested || 0);
  }, [loanAmountRequested]);
  const obj = {
    customerId: id,
    schemaName: SchemaName,
  };
  const handleSetId = (id) => {
    dispatch(getLoanId(obj));
    dispatch(getLoanData(id));
    setVisible(!visible);
    setStatus(true);
  };
  const handleNavigateDisbursement = (id) => {
    dispatch(getLoanId(obj));
    dispatch(getLoanData(id));
    setKey("DISBURSEMENT");
    setStatus(true);
  };
  useEffect(() => {
    dispatch(getLoanId(obj));
  }, [loans]);

  // const handleCheckboxChange = (index, loanid) => {
  //   const newCheckedState = !checkedState[index];
  //   setCheckedState((prevState) => ({
  //     ...prevState,
  //     [index]: newCheckedState,
  //   }));
  //   const newData = {
  //     schemaName: SchemaName,
  //     approvalfilecharge: newCheckedState,
  //   };

  //   const obj = {
  //     id: loanid,
  //     data: newData,
  //   };
  //   dispatch(updateLoan(obj));
  // };
  useEffect(() => {
    if (loandetails?.data) {
      // Initialize checkedState based on approvalfilecharge for each data row
      const initialCheckedState = loandetails.data.map(
        (datas) => datas?.approvalfilecharge || false
      );
      setCheckedState(initialCheckedState);
    }
  }, [loandetails?.data]);
  const handleCheckboxChange = (index, loanid) => {
    // Toggle the checkbox state based on current value
    const newCheckedState = !checkedState[index];

    // Update local checkedState
    setCheckedState((prevState) => ({
      ...prevState,
      [index]: newCheckedState,
    }));

    // Prepare new data for API call
    const newData = {
      schemaName: SchemaName,
      approvalfilecharge: newCheckedState,
    };

    // Create object with loan id and updated data
    const obj = {
      id: loanid,
      data: newData,
    };

    // Dispatch the action to update the loan data via API
    dispatch(updateLoan(obj));
  };

  return (
    <>
      <LoanApproveModal
        customerData={customerData}
        visible={visible}
        setVisible={setVisible}
        checkedState={checkedState}
      />
      <CRow>
        <CCol xs={12}>
          <CCardBody>
            <CContainer>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Your Loans</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol xs={12}>
                      <CCard className="mb-2">
                        <div className="search_bar">
                          <div className="search-inner"></div>
                        </div>
                        <div className="btn_add mt-0 mb-14"></div>
                        <CCardBody>
                          <div>
                            <div>
                              <CTable color="dark" hover responsive>
                                <CTableHead className="tabl-head">
                                  <CTableRow className="table-row">
                                    <CTableHeaderCell scope="col">
                                      Sr No.
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Loan Apply Date
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Product Name
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      MOP
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Down Payment
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Requested Amount
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      File Charges
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Interest Rate
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Approval Date
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Approved Amount
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      File Charge Include
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Status
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Total EMIs
                                    </CTableHeaderCell>
                                    <CTableHeaderCell scope="col">
                                      Action
                                    </CTableHeaderCell>
                                  </CTableRow>
                                </CTableHead>
                                <CTableBody>
                                  {loandetails?.data?.map((datas, index) => (
                                    <CTableRow key={index} className="cursor">
                                      <CTableDataCell>
                                        {index + 1}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.createdAt
                                          ? formatDate(
                                            datas?.createdAt.split("T")[0]
                                          )
                                          : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas.interest.loanType}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.interest?.price ? datas?.interest?.price : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.interest?.price ? (Number(datas?.interest?.price) - Number(datas.requestedAmount)) : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.requestedAmount
                                          ? datas?.requestedAmount
                                          : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.interest?.file_charges
                                          ? datas?.interest?.file_charges
                                          : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.interest?.rate
                                          ? datas?.interest?.rate
                                          : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.approvalDate
                                          ? formatDate(
                                            datas?.approvalDate.split("T")[0]
                                          )
                                          : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.approvalAmount
                                          ? datas?.approvalAmount
                                          : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        <input
                                          type="checkbox"
                                          checked={
                                            checkedState[index] ??
                                            datas?.approvalfilecharge
                                          } // Initialize checkbox state
                                          onChange={() =>
                                            handleCheckboxChange(
                                              index,
                                              datas?.id
                                            )
                                          }
                                        />
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.status ? datas?.status : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.numberOfEmis
                                          ? datas?.numberOfEmis
                                          : "--"}
                                      </CTableDataCell>
                                      <CTableDataCell>
                                        {datas?.status === "pending" &&
                                          datas?.disbursements?.length ===
                                          0 && (
                                            <CButton
                                              onClick={() => handleSetId(datas)}
                                            >
                                              Approve
                                            </CButton>
                                          )}
                                        {datas?.status === "approved" && (
                                          <CButton
                                            onClick={() =>
                                              handleNavigateDisbursement(datas)
                                            }
                                          >
                                            Disbursement
                                          </CButton>
                                        )}
                                      </CTableDataCell>
                                    </CTableRow>
                                  ))}
                                </CTableBody>
                              </CTable>
                            </div>
                          </div>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CContainer>
          </CCardBody>
        </CCol>
      </CRow>
    </>
  );
};

LoanDetailsData.propTypes = {
  customerData: PropTypes.object.isRequired,
  emiData: PropTypes.array.isRequired,
  setKey: PropTypes.func.isRequired,
};

export default LoanDetailsData;
